import { render, staticRenderFns } from "./RefreshLoaderWrapper.vue?vue&type=template&id=13b99bfe&lang=pug"
import script from "./RefreshLoaderWrapper.vue?vue&type=script&lang=ts"
export * from "./RefreshLoaderWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports